import thunkMiddleware from 'redux-thunk';
import history from './history'
import { routerMiddleware } from 'react-router-redux';

export default [
  thunkMiddleware,
  routerMiddleware(history)
];



// WEBPACK FOOTER //
// src/middleware.js